import { useState } from 'react';
import IMPairingCard from './IMPairingCard';
import type { QQConfig } from '../../types/im';
import { i18nService } from '../../services/i18n';

/** QQ凭据表单沿用BoMate手动连接布局；保存与启停由实例服务负责。 */
export default function QQConfigForm({ config, instanceId, pairingAvailable, disabled, onChange, onSave }: {
  config: QQConfig; instanceId: string; pairingAvailable: boolean; disabled: boolean;
  onChange(patch: Partial<QQConfig>): void; onSave(): Promise<void>;
}) {
  const [mode, setMode] = useState<'manual' | 'qr'>(pairingAvailable && !config.appId ? 'qr' : 'manual');
  return <div className="space-y-3">
    {pairingAvailable && <div role="tablist" aria-label={i18nService.t('imQQConnectMode')} className="grid grid-cols-2 gap-1 rounded-lg bg-black/[0.04] p-1 dark:bg-white/[0.05]">
      {(['qr', 'manual'] as const).map(value => <button key={value} type="button" role="tab" aria-selected={mode === value}
        disabled={disabled} onClick={() => setMode(value)} className={`rounded-md px-3 py-2 text-sm ${mode === value ? 'bg-claude-accent text-white' : ''}`}>
        {i18nService.t(value === 'qr' ? 'imPairingStart' : 'imQQManualMode')}
      </button>)}
    </div>}
    {mode === 'qr' ? <IMPairingCard platform="qq" accountId={config.appId} enabled={config.enabled} instanceId={instanceId} disabled={disabled} /> : <>

    <p className="text-xs leading-relaxed text-claude-textSecondary dark:text-claude-darkTextSecondary">{i18nService.t('imQQWebHint')}</p>
    {(['appId', 'appSecret'] as const).map(field => <label key={field} className="block text-sm">
      {field === 'appId' ? 'App ID' : 'App Secret'}
      <input aria-label={`QQ ${field}`} type={field === 'appSecret' ? 'password' : 'text'} autoComplete="off" disabled={disabled}
        value={config[field]} maxLength={1024} onChange={event => onChange({ [field]: event.target.value })} onBlur={() => void onSave()}
        className="mt-1 block w-full rounded-lg border border-claude-border/60 bg-claude-surface px-3 py-2 text-sm dark:border-claude-darkBorder/60 dark:bg-claude-darkSurface" />
    </label>)}
    </>}
  </div>;
}
